var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonadLogoFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 28,
    height: 28,
    rx: 6,
    fill: "#6E54FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 4C12.3036 4 4 12.3034 4 15.9999C4 19.6964 12.3036 28 15.9999 28C19.6962 28 28 19.6963 28 15.9999C28 12.3035 19.6964 4 15.9999 4ZM14.0053 22.3619C12.4466 21.9346 8.25586 14.5841 8.68124 13.0254C9.10662 11.4666 16.4569 7.27593 18.0156 7.7013C19.5743 8.12659 23.7651 15.477 23.3397 17.0358C22.9143 18.5945 15.564 22.7852 14.0053 22.3619Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonadLogoFilled);
export default __webpack_public_path__ + "static/media/Monad-Logo-Filled.04180906c09718bf9f9603fd9895eb2e.svg";
export { ForwardRef as ReactComponent };